// DO NOT EDIT
  // this file is generated by /internals/populate-icons script
  import * as React from 'react'
  // @ts-ignore
  import { ArrowRight } from 'react-feather'
  import IconBase from './../../IconBase'

  function IconArrowRight(props: any) {
    return <IconBase icon={ArrowRight} {...props} />
  }

  export default IconArrowRight
  